export const TENANT_DEEP_LINK_PREFIXES = [
  "/dashboard",
  "/settings/",
  "/roles-permissions-setting",
  "/subscription",
  "/rostering/",
  "/reporting/",
  "/cos/",
  "/ah/",
  "/participant-list",
  "/hrm",
];

export const DEFAULT_TENANT_ENTRY_PATH = "/dashboard";

/**
 * Validates and normalizes a tenant deep-link path for platform admin enter-tenant.
 * Falls back to dashboard when path is missing or not allowlisted.
 */
export const resolveTenantDeepLinkPath = (path) => {
  if (typeof path !== "string" || !path.startsWith("/")) {
    return DEFAULT_TENANT_ENTRY_PATH;
  }

  const normalized = path.split("?")[0];
  const allowed = TENANT_DEEP_LINK_PREFIXES.some(
    (prefix) => normalized === prefix || normalized.startsWith(prefix)
  );

  return allowed ? path : DEFAULT_TENANT_ENTRY_PATH;
};

export const buildTenantDetailSupportReturnPath = (tenantId) =>
  `/tenants/${tenantId}?support=1`;
